import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import { Dialog, DialogContent, Divider, Paper, Typography } from '@mui/material'
import { BasicDialogTitle } from 'common/components/modal/DialogComponents'
import { getFullDate } from 'common/utils/DateUtil'

// Historique des versions de la note partagée (la plus récente en premier).
const GlobalNoteHistoryDialog = ({ open = false, onClose = () => {}, history = [] }) => (
    <Dialog open={open} onClose={onClose} maxWidth='md' fullWidth>
        <BasicDialogTitle onClose={onClose}>Historique de la note partagée</BasicDialogTitle>
        <DialogContent dividers>
            {history.length === 0
                ? <Typography>Aucune version enregistrée.</Typography>
                : history.map((version, index) => (
                    <Fragment key={version.id}>
                        {index > 0 && <Divider sx={{ my: 1.5 }} />}
                        <Typography variant='caption' color='text.secondary'>
                            {`${getFullDate(version.updateDate)}${version.updateLogin ? ` — ${version.updateLogin}` : ''}`}
                        </Typography>
                        <Paper variant='outlined' sx={{ p: 1, mt: 0.5, whiteSpace: 'pre-wrap' }}>
                            {version.comment || <em>(vide)</em>}
                        </Paper>
                    </Fragment>
                ))}
        </DialogContent>
    </Dialog>
)

GlobalNoteHistoryDialog.propTypes = {
    open: PropTypes.bool,
    onClose: PropTypes.func,
    history: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.number,
        comment: PropTypes.string,
        updateDate: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
        updateLogin: PropTypes.string,
    })),
}

export default GlobalNoteHistoryDialog
